<template>
  <div class="container">
    <div
      class="dropbox"
      v-if="!isSuccess && !isFailed"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop"
      :class="{
        'drag-over-success': isFileOk,
        'drag-over-error': isFileError || isFailed,
      }"
    >
      <input
        id="file"
        ref="file"
        type="file"
        :disabled="isSaving"
        @change="handleFileUpload()"
        accept=".xlsx"
        :class="{ 'input-file': true }"
      />
      <p v-if="isInitial">
        Trascia qui il tuo file <b>xlsx</b><br />
        o clicca per caricarlo
      </p>
      <p v-if="isSaving">Processing file...</p>
      <p v-if="isFileOk">
        Formato corretto!<br />
        Rilascia il file!
      </p>
      <p v-if="isFileError">
        Formato <b>NON</b> corretto!<br />
        Prova con un file .xlsx!
      </p>
    </div>
    <!--SUCCESS-->
    <div v-if="isSuccess" class="box-message">
      <h2>
        File "<i>{{ this.file.name }}</i
        >" elaborato con successo!!!
      </h2>

      <div v-if="jacketsIdSizeNotPresent.length > 0" class="warning-box">
        <p>
          Label taglie mancanti - Giacche non elaborate: <br /><br />{{
            jacketsIdSizeNotPresent.join(", ")
          }}
        </p>
      </div>

      <div v-if="pantsIdSizeNotPresent.length > 0" class="warning-box">
        <p>
          Label taglie mancanti - Pantaloni non elaborati: <br /><br />{{
            pantsIdSizeNotPresent.join(", ")
          }}
        </p>
      </div>

      <div
        v-for="out in outputs"
        :key="out.file"
        class="summary-box"
        :class="{ empty: !out.products.length }"
      >
        <p class="summary-row">
          <span
            class="check"
            :class="{
              done: downloaded[out.file],
              disabled: !out.products.length,
            }"
            >{{ downloaded[out.file] ? "✓" : "" }}</span
          >
          <span>
            <b>{{ out.label }}</b>: {{ out.products.length }}
            {{ out.products.length == 1 ? "capo" : "capi" }}
            <span v-if="!out.products.length">- nessun dato da scaricare</span>
          </span>
          <button
            v-if="out.products.length"
            class="download-btn"
            @click="downloadCsv(out)"
          >
            <svg
              viewBox="0 0 24 24"
              width="16"
              height="16"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 3v12M7 10l5 5 5-5M5 21h14" />
            </svg>
            Scarica
          </button>
        </p>
        <p v-if="out.products.length" class="summary-list">
          {{ out.products.join(", ") }}
        </p>
      </div>

      <p>
        <a href="javascript:void(0)" @click="reset()">Upload again</a>
      </p>
    </div>
    <!--FAILED-->
    <div v-if="isFailed" class="box-message">
      <h2>💥 Caricamento fallito.</h2>
      <p>
        <a href="javascript:void(0)" @click="reset()">Riprova</a>
      </p>
      <pre>{{ uploadError }}</pre>
    </div>

    <div class="footer">
      Powerd by <a href="https://www.lab87.it" target="_blank">lab87.it</a>
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx";

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FILE_OK = 21,
  STATUS_FAILED = 3,
  STATUS_FILE_ERROR = 31;

const CSV_CONFIG = {
  quotes: true, //or array of booleans
  quoteChar: '"',
  escapeChar: '"',
  delimiter: ",",
  header: true,
  newline: "\r\n",
  skipEmptyLines: false, //other option is 'greedy', meaning skip delimiters, quotes, and whitespace.
  // columns: null, //or array of strings
};
export default {
  name: "SheetToCsvConverter",
  props: {
    msg: String,
  },
  data() {
    return {
      file: "",
      uploadError: null,
      uploadSuccess: null,
      currentStatus: null,
      excelHeading: [],
      excelData: [],
      importedData: [],
      labelData: [],
      jacketsData: [],
      pantsData: [],
      // cvs data
      topCsvData: [],
      bottomCsvData: [],
      productsCsvData: [],
      productsCsvDataDuplicate: [],
      jacketsIdSizeNotPresent: [],
      pantsIdSizeNotPresent: [],
      downloaded: {},
      processedAt: "",
    };
  },
  computed: {
    outputs() {
      const products = (rows) => [
        ...new Set(
          rows.map((r) => r.title || r.content_name.replace(/_[^_]*$/, "")),
        ),
      ];
      return [
        {
          label: "Giacche",
          file: "content_cms_sizeChartTop",
          rows: this.topCsvData,
          products: products(this.topCsvData),
        },
        {
          label: "Pantaloni",
          file: "content_cms_sizeChartBottom",
          rows: this.bottomCsvData,
          products: products(this.bottomCsvData),
        },
      ];
    },
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isFileOk() {
      return this.currentStatus === STATUS_FILE_OK;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    isFileError() {
      return this.currentStatus === STATUS_FILE_ERROR;
    },
  },
  mounted() {
    this.reset();
  },
  methods: {
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadError = null;
    },
    handleFileUpload() {
      this.currentStatus = STATUS_SAVING;

      // carico il file
      this.file = this.$refs.file.files[0];

      if (this.file == undefined) {
        try {
          throw new Error("File non definito");
        } catch (e) {
          this.currentStatus = STATUS_FAILED;
          this.uploadError = e.name + ": " + e.message;
          console.error(e.name + ": " + e.message);
          return null;
        }
      }

      // genero un eccesione se carico un file invalido
      if (this.file.size == 0) {
        try {
          throw new Error("File con dimensione pari a 0");
        } catch (e) {
          this.currentStatus = STATUS_FAILED;
          this.uploadError = e.name + ": " + e.message;
          console.error(e.name + ": " + e.message);
          return null;
        }
      }

      let reader = new FileReader();
      reader.onload = () => {
        let data = reader.result;
        this.topCsvData = [];
        this.bottomCsvData = [];
        this.jacketsIdSizeNotPresent = [];
        this.pantsIdSizeNotPresent = [];
        this.downloaded = {};
        let d = new Date();
        let pad = (n) => String(n).padStart(2, "0");
        this.processedAt =
          d.getFullYear() +
          pad(d.getMonth() + 1) +
          pad(d.getDate()) +
          "-" +
          pad(d.getHours()) +
          pad(d.getMinutes());

        // controllo che l'intestazione sia corretta
        let arrHeading = [
          [
            "PRODUCT_ID",
            "CLASSE",
            "MODELLO",
            "PARTE",
            "STAGIONE",
            "LINEA",
            "COLONNA",
            "INTESTAZIONE",
            "TITOLO",
            "VALORE1",
            "VALORE2",
            "VALORE3",
            "VALORE4",
            "VALORE5",
            "VALORE6",
            "VALORE7",
            "VALORE8",
            "VALORE9",
            "VALORE10",
            "VALORE11",
            "VALORE12",
            "VALORE13",
            "VALORE14",
            "VALORE15",
            "VALORE16",
          ],
        ];
        let firstRow = XLSX.read(data, { type: "binary", sheetRows: 1 });
        let sheetsList = firstRow.SheetNames;
        let rowObjHeading = XLSX.utils.sheet_to_json(
          firstRow.Sheets[sheetsList[0]],
          {
            header: 1,
            defval: "",
            blankrows: true,
          },
        );
        this.excelHeading = JSON.stringify(rowObjHeading);
        // console.log("⛷", this.excelHeading);

        if (this.excelHeading != JSON.stringify(arrHeading)) {
          try {
            throw new Error("Struttura file non corretta");
          } catch (e) {
            this.currentStatus = STATUS_FAILED;
            this.uploadError = e.name + ": " + e.message;
            console.error(e.name + ": " + e.message);
            return null;
          }
        }

        let workbook = XLSX.read(data, { type: "binary" });
        workbook.SheetNames.forEach((sheetName) => {
          let rowObj = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
            defval: "",
            blankrows: true,
          });
          this.excelData[sheetName] = JSON.stringify(rowObj);
        });

        // -----------------------------------------------------------------------------
        // label data
        // -----------------------------------------------------------------------------
        this.importedData = JSON.parse(
          this.excelData[Object.keys(this.excelData)[0]],
        );
        // console.log(this.importedData);
        let labelData = this.importedData.filter(this.filterByLabel);
        // this.labelData = labelData;
        // reduce
        this.labelData = labelData.reduce((r, a) => {
          let product_id = a.PRODUCT_ID;
          r[product_id] = [...(r[product_id] || []), a];
          return r;
        }, []);
        // console.log("labelData", this.labelData);

        // -----------------------------------------------------------------------------
        // jackets
        // -----------------------------------------------------------------------------
        let jacketsImport = this.importedData.filter(this.filterByJacket);
        // console.log("jackets Import", jacketsImport);

        let groupJacketsData = Object.entries(
          jacketsImport.reduce((r, a) => {
            let product_id = a.PRODUCT_ID;
            r[product_id] = [...(r[product_id] || []), a];
            return r;
          }, []),
        );

        let groupCmJacketsData = [];
        groupJacketsData.forEach((element) => {
          groupCmJacketsData[element[0]] = element[1].reduce((r, a) => {
            let head = a.INTESTAZIONE.replace(/\s+/g, "").replace(/\.+/g, ""); // relace anomal char
            r[head] = [...(r[head] || []), a];
            return r;
          }, []);
          let back = this.pickBackLength(groupCmJacketsData[element[0]]["F"]);
          if (back) groupCmJacketsData[element[0]]["F"] = [back];
          else delete groupCmJacketsData[element[0]]["F"];
        });

        this.jacketsData = groupCmJacketsData;
        // console.log("jacketsData", this.jacketsData);

        // -----------------------------------------------------------------------------
        // PANTS
        // -----------------------------------------------------------------------------
        let pantsImport = this.importedData.filter(this.filterByPant);
        // console.log("pants Import", pantsImport);

        let groupPantsData = Object.entries(
          pantsImport.reduce((r, a) => {
            let product_id = a.PRODUCT_ID;
            r[product_id] = [...(r[product_id] || []), a];
            return r;
          }, []),
        );

        // console.log("groupPantsData", groupPantsData);

        let groupCmPantsData = [];
        groupPantsData.forEach((element) => {
          groupCmPantsData[element[0]] = element[1].reduce((r, a) => {
            let head = a.INTESTAZIONE.replace(/\s+/g, "").replace(/\.+/g, ""); // relace anomal char
            r[head] = [...(r[head] || []), a];
            return r;
          }, []);
        });

        this.pantsData = groupCmPantsData;
        // console.log("pantsData", this.pantsData);
        // // -----------------------------------------------------------------------------

        // -----------------------------------------------------------------------------
        // EXPORT
        // -----------------------------------------------------------------------------
        this.currentStatus = STATUS_SUCCESS;
        // -----------------------------------------------------------------------------
        // TOP CSV
        // -----------------------------------------------------------------------------
        this.generateJacketsCsvData();
        // -----------------------------------------------------------------------------

        // // -----------------------------------------------------------------------------
        // // PANTS CSV
        // // -----------------------------------------------------------------------------
        this.generatePantsCsvData();
        // -----------------------------------------------------------------------------
      };
      reader.readAsBinaryString(this.file);
    },
    outputFileName(prefix) {
      let source = this.file.name
        .replace(/\.xlsx?$/i, "")
        .replace(/[^A-Za-z0-9_-]+/g, "_")
        .replace(/^_+|_+$/g, "");
      return prefix + "_" + source + "_" + this.processedAt;
    },
    downloadCsv(out) {
      this.$papa.download(
        this.$papa.unparse(JSON.stringify(out.rows), CSV_CONFIG),
        this.outputFileName(out.file),
      );
      this.downloaded = { ...this.downloaded, [out.file]: true };
    },
    filterByLabel(item) {
      return item.COLONNA == 100 && item.PRODUCT_ID != ""; // temp filter
    },
    filterByJacket(item) {
      return (
        item.PRODUCT_ID != "" && // temp filter
        item.MODELLO[6] != "P" &&
        item.MODELLO[6] != "A" &&
        item.COLONNA < 200 &&
        (item.INTESTAZIONE == "A" ||
          item.INTESTAZIONE == "B" ||
          item.INTESTAZIONE == "G" ||
          item.INTESTAZIONE == "F" ||
          item.INTESTAZIONE == "F..." ||
          item.INTESTAZIONE == "F.." ||
          item.INTESTAZIONE == "F.")
      );
    },
    filterByPant(item) {
      return (
        item.PRODUCT_ID != "" && // temp filter
        item.MODELLO[6] == "P" &&
        item.COLONNA < 200 &&
        (item.INTESTAZIONE == "C" ||
          item.INTESTAZIONE == "D" ||
          item.INTESTAZIONE == "W" ||
          item.INTESTAZIONE == "X")
      );
    },
    // Righe F per colonna: 108 corto, 109 medio, 110 lungo, 111 irregolare.
    // Priorità concordata con FGF il 13/10/2026; le righe segnaposto (< 20 cm) si scartano.
    pickBackLength(rows) {
      if (rows == undefined) return undefined;
      const priority = [109, 108, 110, 111];
      const rank = (row) => priority.indexOf(Number(row.COLONNA));
      const isReal = (row) => {
        let max = 0;
        for (let i = 1; i <= 16; i++) {
          let v = row["VALORE" + i];
          if (v !== "" && v != null && !isNaN(v)) max = Math.max(max, v);
        }
        return max >= 20;
      };
      return rows.filter(isReal).sort((a, b) => rank(a) - rank(b))[0];
    },
    anomali(item) {
      return item[1].length > 4;
    },
    // Legge una misura da element[letter] alla colonna valIndex, in modo
    // protetto: "" se la misura non e presente (evita crash su undefined).
    // mult: fattore moltiplicativo (es. 2 per le semi-circonferenze).
    // inch: converte in pollici. Con mult assente torna il cm grezzo.
    measure(element, letter, valIndex, mult, inch) {
      if (element[letter] == undefined) return "";
      let v = element[letter][0]["VALORE" + (valIndex + 1)];
      // cella vuota/non numerica -> vuoto (evita "0.00" fittizi)
      if (v === "" || v == null || isNaN(v)) return "";
      if (mult == undefined) return v;
      v = v * mult;
      if (inch) v = v * 0.393701;
      return v.toFixed(2);
    },
    generatePantsCsvData() {
      // per ogni pants presente faccio una riga
      this.pantsData.forEach((element, key) => {
        // key è il product_id
        if (this.labelData[key]) {
          let arrTopTemp = {
            content_type: "block_sizeChart",
            content_id: "",
            content_name:
              this.labelData[key][0].MODELLO +
              "-" +
              this.labelData[key][0].PARTE,
            date_created: "",
            is_published: 1,
            language: "default",
            date_start: "",
            date_end: "",
            title:
              this.labelData[key][0].MODELLO +
              "-" +
              this.labelData[key][0].PARTE,
            fit_description: "",
            id_product: this.labelData[key][0].PRODUCT_ID,
            inch_international_sizing: "",
            sizes: "",
          };
          // arrTopTemp["id_product"] = this.labelData[key][0].PRODUCT_ID;
          let sizeIndex = 0;
          let valIndex = 0;
          do {
            while (
              valIndex < 16 &&
              (this.labelData[key][0]["VALORE" + (valIndex + 1)] == "" ||
                this.labelData[key][0]["VALORE" + (valIndex + 1)] == null ||
                this.labelData[key][0]["VALORE" + (valIndex + 1)] == undefined)
            ) {
              valIndex++;
            }
            if (valIndex < 16) {
              let size = this.labelData[key][0]["VALORE" + (valIndex + 1)]
                .toString() // fix on blauer-mapper
                .replace(/\s+/g, "")
                .replace("-", "");
              let insideLeg = this.measure(element, "X", valIndex);
              if (insideLeg !== "" && insideLeg < 50) {
                arrTopTemp["sizes#size." + sizeIndex] = size;
                arrTopTemp["sizes#shoulder_cm." + sizeIndex] = "";
                arrTopTemp["sizes#shoulder_inch." + sizeIndex] = "";
                arrTopTemp["sizes#arm_cm." + sizeIndex] = "";
                arrTopTemp["sizes#arm_inch." + sizeIndex] = "";
                arrTopTemp["sizes#pit_to_tip_cm." + sizeIndex] = "";
                arrTopTemp["sizes#pit_to_tip_inch." + sizeIndex] = "";
                arrTopTemp["sizes#back_cm." + sizeIndex] = "";
                arrTopTemp["sizes#back_inch." + sizeIndex] = "";
                arrTopTemp["image" + sizeIndex] = "";
                arrTopTemp["sizes#is_shorts." + sizeIndex] = 1;
                arrTopTemp["sizes#shorts_waist_cm." + sizeIndex] =
                  this.measure(element, "C", valIndex, 2);
                arrTopTemp["sizes#shorts_waist_inch." + sizeIndex] =
                  this.measure(element, "C", valIndex, 2, true);
                arrTopTemp["sizes#shorts_rise_cm." + sizeIndex] = "";
                arrTopTemp["sizes#shorts_rise_inch." + sizeIndex] = "";
                arrTopTemp["sizes#shorts_inside_leg_cm." + sizeIndex] =
                  this.measure(element, "X", valIndex);
                arrTopTemp["sizes#shorts_inside_leg_inch." + sizeIndex] =
                  this.measure(element, "X", valIndex, 1, true);
                arrTopTemp["sizes#is_pants." + sizeIndex] = "";
                arrTopTemp["sizes#pants_waist_cm." + sizeIndex] = "";
                arrTopTemp["sizes#pants_waist_inch." + sizeIndex] = "";
                arrTopTemp["sizes#pants_rise_cm." + sizeIndex] = "";
                arrTopTemp["sizes#pants_rise_inch." + sizeIndex] = "";
                arrTopTemp["sizes#pants_thigh_cm." + sizeIndex] = "";
                arrTopTemp["sizes#pants_thigh_inch." + sizeIndex] = "";
                arrTopTemp["sizes#pants_inside_leg_cm." + sizeIndex] = "";
                arrTopTemp["sizes#pants_inside_leg_inch." + sizeIndex] = "";
                arrTopTemp["sizes#pants_ankle_cm." + sizeIndex] = "";
                arrTopTemp["sizes#pants_ankle_inch." + sizeIndex] = "";
                arrTopTemp["sizes#is_jaket." + sizeIndex] = "";
              } else {
                arrTopTemp["sizes#size." + sizeIndex] = size;
                arrTopTemp["sizes#shoulder_cm." + sizeIndex] = "";
                arrTopTemp["sizes#shoulder_inch." + sizeIndex] = "";
                arrTopTemp["sizes#arm_cm." + sizeIndex] = "";
                arrTopTemp["sizes#arm_inch." + sizeIndex] = "";
                arrTopTemp["sizes#pit_to_tip_cm." + sizeIndex] = "";
                arrTopTemp["sizes#pit_to_tip_inch." + sizeIndex] = "";
                arrTopTemp["sizes#back_cm." + sizeIndex] = "";
                arrTopTemp["sizes#back_inch." + sizeIndex] = "";
                arrTopTemp["image" + sizeIndex] = "";
                arrTopTemp["sizes#is_shorts." + sizeIndex] = "";
                arrTopTemp["sizes#shorts_waist_cm." + sizeIndex] = "";
                arrTopTemp["sizes#shorts_waist_inch." + sizeIndex] = "";
                arrTopTemp["sizes#shorts_rise_cm." + sizeIndex] = "";
                arrTopTemp["sizes#shorts_rise_inch." + sizeIndex] = "";
                arrTopTemp["sizes#shorts_inside_leg_cm." + sizeIndex] = "";
                arrTopTemp["sizes#shorts_inside_leg_inch." + sizeIndex] = "";
                arrTopTemp["sizes#is_pants." + sizeIndex] = 1;
                arrTopTemp["sizes#pants_waist_cm." + sizeIndex] =
                  this.measure(element, "C", valIndex, 2);
                arrTopTemp["sizes#pants_waist_inch." + sizeIndex] =
                  this.measure(element, "C", valIndex, 2, true);
                arrTopTemp["sizes#pants_rise_cm." + sizeIndex] = "";
                arrTopTemp["sizes#pants_rise_inch." + sizeIndex] = "";
                arrTopTemp["sizes#pants_thigh_cm." + sizeIndex] =
                  this.measure(element, "W", valIndex);
                arrTopTemp["sizes#pants_thigh_inch." + sizeIndex] =
                  this.measure(element, "W", valIndex, 1, true);
                arrTopTemp["sizes#pants_inside_leg_cm." + sizeIndex] =
                  this.measure(element, "X", valIndex);
                arrTopTemp["sizes#pants_inside_leg_inch." + sizeIndex] =
                  this.measure(element, "X", valIndex, 1, true);
                arrTopTemp["sizes#pants_ankle_cm." + sizeIndex] = "";
                arrTopTemp["sizes#pants_ankle_inch." + sizeIndex] = "";
                arrTopTemp["sizes#is_jaket." + sizeIndex] = "";
              }
            } else {
              arrTopTemp["sizes#size." + sizeIndex] = "";
              arrTopTemp["sizes#shoulder_cm." + sizeIndex] = "";
              arrTopTemp["sizes#shoulder_inch." + sizeIndex] = "";
              arrTopTemp["sizes#arm_cm." + sizeIndex] = "";
              arrTopTemp["sizes#arm_inch." + sizeIndex] = "";
              arrTopTemp["sizes#pit_to_tip_cm." + sizeIndex] = "";
              arrTopTemp["sizes#pit_to_tip_inch." + sizeIndex] = "";
              arrTopTemp["sizes#back_cm." + sizeIndex] = "";
              arrTopTemp["sizes#back_inch." + sizeIndex] = "";
              arrTopTemp["image" + sizeIndex] = "";
              arrTopTemp["sizes#is_shorts." + sizeIndex] = "";
              arrTopTemp["sizes#shorts_waist_cm." + sizeIndex] = "";
              arrTopTemp["sizes#shorts_waist_inch." + sizeIndex] = "";
              arrTopTemp["sizes#shorts_rise_cm." + sizeIndex] = "";
              arrTopTemp["sizes#shorts_rise_inch." + sizeIndex] = "";
              arrTopTemp["sizes#shorts_inside_leg_cm." + sizeIndex] = "";
              arrTopTemp["sizes#shorts_inside_leg_inch." + sizeIndex] = "";
              arrTopTemp["sizes#is_pants." + sizeIndex] = "";
              arrTopTemp["sizes#pants_waist_cm." + sizeIndex] = "";
              arrTopTemp["sizes#pants_waist_inch." + sizeIndex] = "";
              arrTopTemp["sizes#pants_rise_cm." + sizeIndex] = "";
              arrTopTemp["sizes#pants_rise_inch." + sizeIndex] = "";
              arrTopTemp["sizes#pants_thigh_cm." + sizeIndex] = "";
              arrTopTemp["sizes#pants_thigh_inch." + sizeIndex] = "";
              arrTopTemp["sizes#pants_inside_leg_cm." + sizeIndex] = "";
              arrTopTemp["sizes#pants_inside_leg_inch." + sizeIndex] = "";
              arrTopTemp["sizes#pants_ankle_cm." + sizeIndex] = "";
              arrTopTemp["sizes#pants_ankle_inch." + sizeIndex] = "";
              arrTopTemp["sizes#is_jaket." + sizeIndex] = "";
            }

            sizeIndex++;
            valIndex++;
          } while (sizeIndex < 16);
          this.bottomCsvData.push(arrTopTemp);
        } else {
          if (this.pantsIdSizeNotPresent.indexOf(key) == -1) {
            this.pantsIdSizeNotPresent.push(key);
          }
        }

        // console.log("🖨", this.bottomCsvData);
      });

      // console.log("🖨", this.bottomCsvData);
    },
    generateJacketsCsvData() {
      // per ogni jacket presente faccio una riga
      this.jacketsData.forEach((element, key) => {
        // key è il product_id
        if (this.labelData[key]) {
          let arrTopTemp = {
            content_type: "block_sizeChart",
            content_id: "",
            content_name:
              this.labelData[key][0].MODELLO +
              "-" +
              this.labelData[key][0].PARTE,
            date_created: "",
            is_published: 1,
            language: "default",
            date_start: "",
            date_end: "",
            title:
              this.labelData[key][0].MODELLO +
              "-" +
              this.labelData[key][0].PARTE,
            fit_description: "",
            id_product: this.labelData[key][0].PRODUCT_ID,
            inch_international_sizing: "",
            sizes: "",
          };
          // arrTopTemp["id_product"] = this.labelData[key][0].PRODUCT_ID;
          let sizeIndex = 0;
          let valIndex = 0;
          do {
            while (
              valIndex < 16 &&
              (this.labelData[key][0]["VALORE" + (valIndex + 1)] == "" ||
                this.labelData[key][0]["VALORE" + (valIndex + 1)] == null ||
                this.labelData[key][0]["VALORE" + (valIndex + 1)] == undefined)
            ) {
              valIndex++;
            }
            if (valIndex < 16) {
              let size = this.labelData[key][0]["VALORE" + (valIndex + 1)]
                .toString() // fix on blauer-mapper
                .replace(/\s+/g, "")
                .replace("-", "");
              arrTopTemp["sizes#size." + sizeIndex] = size;
              arrTopTemp["sizes#shoulder_cm." + sizeIndex] =
                this.measure(element, "A", valIndex);
              arrTopTemp["sizes#shoulder_inch." + sizeIndex] =
                this.measure(element, "A", valIndex, 1, true);
              arrTopTemp["sizes#arm_cm." + sizeIndex] =
                this.measure(element, "G", valIndex);
              arrTopTemp["sizes#arm_inch." + sizeIndex] =
                this.measure(element, "G", valIndex, 1, true);
              arrTopTemp["sizes#pit_to_tip_cm." + sizeIndex] =
                this.measure(element, "B", valIndex, 2);
              arrTopTemp["sizes#pit_to_tip_inch." + sizeIndex] =
                this.measure(element, "B", valIndex, 2, true);
              arrTopTemp["sizes#back_cm." + sizeIndex] =
                this.measure(element, "F", valIndex);
              arrTopTemp["sizes#back_inch." + sizeIndex] =
                this.measure(element, "F", valIndex, 1, true);
              arrTopTemp["image" + sizeIndex] = "";
              arrTopTemp["sizes#is_shorts." + sizeIndex] = "";
              arrTopTemp["sizes#shorts_waist_cm." + sizeIndex] = "";
              arrTopTemp["sizes#shorts_waist_inch." + sizeIndex] = "";
              arrTopTemp["sizes#shorts_rise_cm." + sizeIndex] = "";
              arrTopTemp["sizes#shorts_rise_inch." + sizeIndex] = "";
              arrTopTemp["sizes#shorts_inside_leg_cm." + sizeIndex] = "";
              arrTopTemp["sizes#shorts_inside_leg_inch." + sizeIndex] = "";
              arrTopTemp["sizes#is_pants." + sizeIndex] = "";
              arrTopTemp["sizes#pants_waist_cm." + sizeIndex] = "";
              arrTopTemp["sizes#pants_waist_inch." + sizeIndex] = "";
              arrTopTemp["sizes#pants_rise_cm." + sizeIndex] = "";
              arrTopTemp["sizes#pants_rise_inch." + sizeIndex] = "";
              arrTopTemp["sizes#pants_thigh_cm." + sizeIndex] = "";
              arrTopTemp["sizes#pants_thigh_inch." + sizeIndex] = "";
              arrTopTemp["sizes#pants_inside_leg_cm." + sizeIndex] = "";
              arrTopTemp["sizes#pants_inside_leg_inch." + sizeIndex] = "";
              arrTopTemp["sizes#pants_ankle_cm." + sizeIndex] = "";
              arrTopTemp["sizes#pants_ankle_inch." + sizeIndex] = "";
              arrTopTemp["sizes#is_jaket." + sizeIndex] = 1;
            } else {
              arrTopTemp["sizes#size." + sizeIndex] = "";
              arrTopTemp["sizes#shoulder_cm." + sizeIndex] = "";
              arrTopTemp["sizes#shoulder_inch." + sizeIndex] = "";
              arrTopTemp["sizes#arm_cm." + sizeIndex] = "";
              arrTopTemp["sizes#arm_inch." + sizeIndex] = "";
              arrTopTemp["sizes#pit_to_tip_cm." + sizeIndex] = "";
              arrTopTemp["sizes#pit_to_tip_inch." + sizeIndex] = "";
              arrTopTemp["sizes#back_cm." + sizeIndex] = "";
              arrTopTemp["sizes#back_inch." + sizeIndex] = "";
              arrTopTemp["image" + sizeIndex] = "";
              arrTopTemp["sizes#is_shorts." + sizeIndex] = "";
              arrTopTemp["sizes#shorts_waist_cm." + sizeIndex] = "";
              arrTopTemp["sizes#shorts_waist_inch." + sizeIndex] = "";
              arrTopTemp["sizes#shorts_rise_cm." + sizeIndex] = "";
              arrTopTemp["sizes#shorts_rise_inch." + sizeIndex] = "";
              arrTopTemp["sizes#shorts_inside_leg_cm." + sizeIndex] = "";
              arrTopTemp["sizes#shorts_inside_leg_inch." + sizeIndex] = "";
              arrTopTemp["sizes#is_pants." + sizeIndex] = "";
              arrTopTemp["sizes#pants_waist_cm." + sizeIndex] = "";
              arrTopTemp["sizes#pants_waist_inch." + sizeIndex] = "";
              arrTopTemp["sizes#pants_rise_cm." + sizeIndex] = "";
              arrTopTemp["sizes#pants_rise_inch." + sizeIndex] = "";
              arrTopTemp["sizes#pants_thigh_cm." + sizeIndex] = "";
              arrTopTemp["sizes#pants_thigh_inch." + sizeIndex] = "";
              arrTopTemp["sizes#pants_inside_leg_cm." + sizeIndex] = "";
              arrTopTemp["sizes#pants_inside_leg_inch." + sizeIndex] = "";
              arrTopTemp["sizes#pants_ankle_cm." + sizeIndex] = "";
              arrTopTemp["sizes#pants_ankle_inch." + sizeIndex] = "";
              arrTopTemp["sizes#is_jaket." + sizeIndex] = "";
            }

            sizeIndex++;
            valIndex++;
          } while (sizeIndex < 16);
          this.topCsvData.push(arrTopTemp);
        } else {
          if (this.jacketsIdSizeNotPresent.indexOf(key) == -1) {
            this.jacketsIdSizeNotPresent.push(key);
          }
        }
      });
      // console.log("🖨", this.topCsvData);
    },
    dragover(event) {
      event.preventDefault();
      if (
        event.dataTransfer.items[0].type ==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        this.currentStatus = STATUS_FILE_OK;
      } else {
        this.currentStatus = STATUS_FILE_ERROR;
      }
    },
    dragleave() {
      // Clean up
      this.currentStatus = STATUS_INITIAL;
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      if (
        event.dataTransfer.files[0].type ==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        this.handleFileUpload(); // Trigger the onChange event manually
      } else {
        this.reset();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dropbox {
  outline: 2px dashed white; /* the dash box */
  outline-offset: -10px;
  /*background: #2a2a3c;*/
  color: white;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
  margin: 50px auto;
  max-width: 1070px;
}
.box-message {
  min-height: 200px; /* minimum height */
  margin: 50px auto;
  max-width: 1070px;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  top: 0;
  left: 0;
  height: 234px;
  position: absolute;
  cursor: pointer;
}
.dropbox:hover {
  background: #2a2a3c;
}
.drag-over-success {
  outline: 2px solid #2ffd86; /* the dash box */
}
.drag-over-error {
  outline: 2px solid red; /* the dash box */
}

.dropbox p {
  font-size: 1.5rem;
  text-align: center;
  padding: 50px 0;
}
.footer {
  font-size: 0.8rem;
  color: #fff;
}
.footer a {
  color: #fff;
  text-decoration: none;
}
a {
  color: #fff;
}
.summary-box {
  background: #fff;
  color: #222;
  border-left: 6px solid #2e7d32;
  padding: 10px 16px;
  margin-bottom: 10px;
  text-align: left;
}
.summary-box.empty {
  border-left-color: #888;
  color: #555;
}
.summary-row {
  display: flex;
  align-items: center;
}
.download-btn {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: #2e7d32;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font: inherit;
}
.download-btn:hover {
  background: #1b5e20;
}
.check {
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 18px;
  margin-right: 10px;
  border: 2px solid #2e7d32;
  border-radius: 3px;
  text-align: center;
  vertical-align: middle;
  font-weight: bold;
  color: #fff;
}
.check.done {
  background: #2e7d32;
}
.check.disabled {
  border-color: #bbb;
}
.summary-list {
  font-size: 0.85em;
  color: #444;
  margin-top: 0;
}
.warning-box {
  outline: 2px solid orange; /* the dash box */
  padding: 10px;
  margin-bottom: 10px;
}
</style>
